import { render, staticRenderFns } from "./GBrandItem.vue?vue&type=template&id=9666fee4&scoped=true&"
import script from "./GBrandItem.vue?vue&type=script&lang=ts&"
export * from "./GBrandItem.vue?vue&type=script&lang=ts&"
import style0 from "./GBrandItem.vue?vue&type=style&index=0&id=9666fee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9666fee4",
  null
  
)

export default component.exports